import { BaseDTO } from '../global/base.dto';

export class NotificationDTO extends BaseDTO {

    id: string;

    name: string;

    entity: number;

    event: number;

    type: number;

    body: string;

    active: boolean;

    from: Date;

    to: Date;

    monday: boolean;

    tuesday: boolean;

    wednesday: boolean;

    thursday: boolean;

    friday: boolean;

    saturday: boolean;

    sunday: boolean;

}
